module.exports = __webpack_public_path__ + "img/image_03.631a548d.jpg";